<template>
  <div class="CdkColorPicker">
    <div class="CdkColorPicker-label u-h3 u-mb3">{{ $t("chooseAColor") }}*</div>
    <div>
      <div
        v-for="(chunk, index) in chunks"
        :key="`chunk:${index}`"
        class="Grid"
      >
        <div
          v-for="(item, index) in chunk"
          :key="`item:${index}`"
          class="Grid-cell u-sizeFit"
        >
          <input
            v-if="index === 9"
            id="color"
            type="color"
            v-model="internalValue"
            class="CdkColorPicker-input"
          />
          <div
            :id="`color-${item.replace(/#/g, '')}`"
            class="CdkColorPicker-color u-mb3 u-mr3 u-flex u-flexJustifyCenter u-flexAlignItemsCenter"
            :style="{
              backgroundColor:
                index === 9 && customColorSelected ? internalValue : item
            }"
            @click="
              handleColorClick(item);
              useMatomoEvent({
                category: 'Suche Speichern',
                action: 'Click colors',
                name: 'Choose Color'
              });
            "
          >
            <v-icon v-if="item === value" color="white" size="18px"
              >check</v-icon
            >
            <v-icon
              v-if="index === 9"
              :color="customColorSelected ? 'white' : 'black'"
              size="18px"
            >
              {{ customColorSelected ? "check" : "palette" }}
            </v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import colors from "vuetify/es5/util/colors";
import chunk from "lodash.chunk";
import useMatomoEvent from "@/composition/useMatomoEvent";

/**
 * The color picker eposes a fixed set of material UI colors and a custom color
 * selection mechanism. It emits an 'input' event when the color value changes.
 *
 * @module components/CdkColorPicker
 * @param {String} value=colors.grey.base The color code in hexadecimal notation
 */
export default defineComponent({
  setup() {
    return { useMatomoEvent };
  },
  data() {
    return {
      swatches: [
        colors.red.darken1,
        colors.pink.accent3,
        colors.purple.darken1,
        colors.blue.base,
        colors.cyan.darken1,
        colors.teal.darken1,
        colors.green.accent3,
        colors.yellow.accent2,
        colors.amber.darken1,
        colors.blueGrey.lighten4
      ]
    };
  },
  props: {
    value: {
      type: String,
      default: colors.grey.base
    }
  },
  computed: {
    chunks() {
      return chunk(this.swatches, 10);
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    customColorSelected() {
      return this.internalValue && !this.swatches.includes(this.internalValue);
    }
  },
  methods: {
    handleColorClick(value) {
      this.internalValue = value;
    }
  }
});
</script>
<style postcss>
@import "suitcss-components-grid";
@import "suitcss-utils-size";
@import "suitcss-utils-display";
@import "../../utils/utils-color/index.css";
@import "../../utils/utils-margin.css";

/** @define CdkColorPicker */

.CdkColorPicker-color {
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.CdkColorPicker-input {
  opacity: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  cursor: pointer;
}
</style>
